import React from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import Lottie from 'react-lottie';
import Button from '@components/common/button';
import Icon from '@components/common/assets';
import fireCracker from '@graphic/fireCracker.json';
import { V2RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const options = {
  loop: true,
  autoplay: true,
  animationData: fireCracker,
};

const Welcome = () => {
  const router = useRouter();
  const notPreffered = router.query?.redirectUrl;

  return (
    <div className={cx('welcomePage')}>
      <div className={cx('header')}>
        <div className={cx('logo')}>
          <Icon name="logo" width={80} height={18} />
          <span className={cx('hidden')}>JOBDA</span>
        </div>
      </div>

      <div className={cx('welcomeMessage')}>
        <div className={cx('lottieArea')}>
          <Lottie options={options} />
        </div>
        <h1 className={cx('title')}>JOBDA 회원가입을 축하합니다!</h1>
        <p className={cx('description')}>
          프로필 정보 초간단 입력하고
          <br />
          나에게 딱 맞는 포지션 추천과 입사 제안 받아보세요.
        </p>
        <Link className={cx('btnNext')} href={notPreffered ? String(notPreffered) : V2RouteUrl.PREFERRED}>
          <Button>다음</Button>
        </Link>
      </div>
    </div>
  );
};

export default Welcome;
